import React, { Component } from 'react';
let self;
class Mic extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            isToggleOn: false,
            totalTO: '',
            intermedTO: '' 
        };
    }

    initRecord() {
        let playButton = this.refs.mic;
        let totalTO = this.state.totalTO;
        let intermedTO = this.state.intermedTO;
        let isToggleOn = this.state.isToggleOn;
        //console.log(isToggleOn);
        /*
            playButton.addEventListener('click',  (e) => {
                if (isToggleOn) {
                    playButton.dispatchEvent(new Event('pause'));
                } else {
                    //console.log("dispatching play");

                    if(!playButton.classList.contains("mic")) 
                        return;
                    if(this.props.isSpeech && !JSON.parse(this.props.isSpeech)){
                        console.log("Request the Admin to enable voice support ! :) ")
                        this.removeMicComponent();
                        return
                    }

                    playButton.dispatchEvent(new Event('play'));
                }
            }, true);
        */

        playButton.addEventListener('pause', function (e) {
            if (totalTO) {
                clearTimeout(totalTO);
            }
            if (intermedTO) {
                clearTimeout(intermedTO);
            }
            playButton.classList.remove('recording');
            //set the input in state
            let mockEvent = new Event("keyup");
        ///
            let event;
            if(typeof(Event) === 'function') {
                event = mockEvent;
              
            }else{
                event = document.createEvent('Event');
                event.initEvent(mockEvent, true, true);
           
            }
           document.getElementById("chatInput").dispatchEvent(event);

         //   document.getElementById("chatInput").dispatchEvent(mockEvent);

            self.props.handleInput.call(self,mockEvent)
            self.props.handleKeyUp.call(self,{keyCode:13},'Mic')
            //playButton.classList.remove("mic")
            //playButton.click();
        });
    }

    isMicEnabled(){
        return this.props.isSpeech ? JSON.parse(this.props.isSpeech) : false ;
    }

    isMicVisible(){
        return this.refs.mic.classList.contains("mic");
    }
    

    handleClick(){
        if(this.isMicEnabled() && this.isMicVisible()){
            if (this.state.isToggleOn) {
                ///
                let event;
                if(typeof(Event) === 'function') {
                    event = new Event('pause');
                }else{
                  event = document.createEvent('Event');
                  event.initEvent('pause', true, true);
                }
                this.refs.mic.dispatchEvent( event );

            //    this.refs.mic.dispatchEvent(new Event('pause'));
            } else {
                  ///
                  let event;
                  if(typeof(Event) === 'function') {
                      event = new Event('play');
                  }else{
                    event = document.createEvent('Event');
                    event.initEvent('play', true, true);
                  }
                  this.refs.mic.dispatchEvent( event );
  
               // this.refs.mic.dispatchEvent(new Event('play'));
            }
        }else{
            // handle inputSubmit
            this.removeMicComponent();
            this.props.handleSubmit.call(this,false,'UserText');
        }
    }

    removeMicComponent(){
        this.refs.mic.classList.contains("mic") ?
        this.refs.mic.classList.remove("mic") : null
    }

    componentDidMount() {
        self = this;
        if(this.props.isSpeech && !JSON.parse(this.props.isSpeech)){ //speech is not enabled
            this.removeMicComponent();
        }

        //if(this.refs.mic.classList.contains("mic")){
            this.initRecord();
        //};
        let synth = window.speechSynthesis;
        let totalTO = this.state.totalTO;
        let intermedTO = this.state.intermedTO;

        if (!window.AudioContext) {
            console.log("Web Audio isn't available in your browser.");
            return;
        }

        let SAMPLE_RATE = 16000;
        let SAMPLE_SIZE = 16;

        let playButton = this.refs.mic;

        var context = new AudioContext();
        playButton.addEventListener('pause', context.suspend.bind(context));
        playButton.addEventListener('play', context.resume.bind(context));

        // The first time you hit play, connect to the microphone
        //playButton.addEventListener('play', function startRecording() {
        playButton.addEventListener('play', () => {
            var audioPromise = navigator.mediaDevices.getUserMedia({
                audio: {
                    echoCancellation: true,
                    channelCount: 1,
                    sampleRate: {
                        ideal: SAMPLE_RATE
                    },
                    sampleSize: SAMPLE_SIZE
                }
            });

            audioPromise.then(function (micStream) {
                var microphone = context.createMediaStreamSource(micStream);
            }).catch(console.log.bind(console));

            initWebsocket(audioPromise);
        }, { once: true });

        function initWebsocket(audioPromise) {
            var socket;
            var sourceNode;

            // Create a node that sends raw bytes across the websocket
            var scriptNode = context.createScriptProcessor(4096, 1, 1);
            // Need the maximum value for 16-bit signed samples, to convert from float.
            var MAX_INT = Math.pow(2, 16 - 1) - 1;
            scriptNode.addEventListener('audioprocess', function (e) {
                var floatSamples = e.inputBuffer.getChannelData(0);
                // The samples are floats in range [-1, 1]. Convert to 16-bit signed
                // integer.
                socket.send(Int16Array.from(floatSamples.map(function (n) {
                    return n * MAX_INT;
                })));
            });

            function newWebsocket() {
                var websocketPromise = new Promise(function (resolve, reject) {
                    //var socket = new WebSocket('wss://' + location.host + '/transcribe');
                    var socket = new WebSocket('wss://' + 'speech.senseforth.com' + '/transcribe');
                    //var socket = new WebSocket('wss://' + 'localhost:8443' + '/transcribe');
                    socket.addEventListener('open', resolve);
                    socket.addEventListener('error', reject);
                });

                Promise.all([audioPromise, websocketPromise]).then(function (values) {
                    //var playButton = document.getElementsByClassName("mic")[0];
                    playButton.classList.remove('record');
                    playButton.classList.remove('recorder-loading');
                    playButton.classList.add('recording');
                    if (totalTO) {
                        clearTimeout(totalTO);
                    }
                    totalTO = setTimeout(function () {
                        if (intermedTO) {
                            clearTimeout(intermedTO);
                        }
                          ///
                        let event;
                        if(typeof(Event) === 'function') {
                            event = new Event('pause');
                        }else{
                        event = document.createEvent('Event');
                        event.initEvent('pause', true, true);
                        }
                        playButton.dispatchEvent( event );

                     //   playButton.dispatchEvent(new Event('pause'));
                    }, 10000);


                    var micStream = values[0];
                    socket = values[1].target;

                    // If the socket is closed for whatever reason, pause the mic
                    socket.addEventListener('close', function (e) {
                        //console.log('Websocket closing..');
                            ///
                            let event;
                            if(typeof(Event) === 'function') {
                                event = new Event('pause');
                            }else{
                            event = document.createEvent('Event');
                            event.initEvent('pause', true, true);
                            }
                            playButton.dispatchEvent( event );
                       // playButton.dispatchEvent(new Event('pause'));
                    });
                    socket.addEventListener('error', function (e) {
                        console.log('Error from websocket', e);
                            ///
                            let event;
                            if(typeof(Event) === 'function') {
                                event = new Event('pause');
                            }else{
                            event = document.createEvent('Event');
                            event.initEvent('pause', true, true);
                            }
                            playButton.dispatchEvent( event );
                      //  playButton.dispatchEvent(new Event('pause'));
                    });

                    function startByteStream(e) {
                        // Hook up the scriptNode to the mic
                        sourceNode = context.createMediaStreamSource(micStream);
                        sourceNode.connect(scriptNode);
                        scriptNode.connect(context.destination);
                    }

                    // Send the initial configuration message. When the server acknowledges
                    // it, start streaming the audio bytes to the server and listening for
                    // transcriptions.
                    socket.addEventListener('message', function (e) {
                        socket.addEventListener('message', onTranscription);
                        startByteStream(e);
                    }, { once: true });

                    function onTranscription(e) {
                        if (intermedTO) {
                            clearTimeout(intermedTO);
                        }
                        var result = e.data && JSON.parse(e.data);
                        //insert this line in prod!!!
                        var inputBox = document.getElementById("chatInput");
                        //var playButton = this.refs.mic;
                        intermedTO = setTimeout(function () {
                            if (totalTO) {
                                clearTimeout(totalTO);
                            }
                                ///
                            let event;
                            if(typeof(Event) === 'function') {
                                event = new Event('pause');
                            }else{
                            event = document.createEvent('Event');
                            event.initEvent('pause', true, true);
                            }
                            playButton.dispatchEvent( event );
                            //playButton.dispatchEvent(new Event('pause'));
                        }, 3000);
                        if (result.alternatives_) {
                            //console.log(result.alternatives_[0]);
                            inputBox.value = result.alternatives_[0].transcript_;

                            // result.alternatives_[0].transcript_.split("").map((e,i) => {
                            //     self.props.handleKeyUp.call(self,{key:e})
                            // })

                        }
                        if (result.isFinal_) {
                            inputBox.value = result.alternatives_[0].transcript_;

                            // result.alternatives_[0].transcript_.split("").map((e,i) => {
                            //     self.props.handleKeyUp.call(self,{key:e})
                            // })
                           // self.props.handleInput(new Event("submit",{target:inputBox}))

                            clearTimeout(totalTO);
                            clearTimeout(intermedTO);
                                ///
                            let event;
                            if(typeof(Event) === 'function') {
                                event = new Event('pause');
                            }else{
                            event = document.createEvent('Event');
                            event.initEvent('pause', true, true);
                            }
                            playButton.dispatchEvent( event );
                           // playButton.dispatchEvent(new Event('pause'));
                        }
                    }

                    socket.send(JSON.stringify({ sampleRate: context.sampleRate, locale: "en-US" }));

                }).catch(console.log.bind(console));
            }

            function closeWebsocket() {
                scriptNode.disconnect();
                if (sourceNode) sourceNode.disconnect();
                if (socket && socket.readyState === socket.OPEN) socket.close();
            }

            function toggleWebsocket(e) {
                var context = e.target;
                if (context.state === 'running') {
                    newWebsocket();
                } else if (context.state === 'suspended') {
                    closeWebsocket();
                }
            }

            // When the mic is resumed or paused, change the state of the websocket too
            context.addEventListener('statechange', toggleWebsocket);
            // initialize for the current state
            toggleWebsocket({ target: context });
        }
    }
    
    render() {
        return (
            <div className="sf-btn-wrapper">
                <div onClick={this.handleClick.bind(this)} 
                    id="send-msg"
                    ref="mic"
                    className={`sf-input-btns ${(this.props.chatInput.length <= 0 && this.props.isSpeech && JSON.parse(this.props.isSpeech)) ? (
                        this.state.isToggleOn ? "mic recording" : "mic"
                    ) : ""}`}
                >
                </div>
            </div>
        );
    }
}


let SFMic = {
    Mic : Mic
}

export default SFMic;

// .send-msg {
//     background-color: black;
//     background-repeat: no-repeat;
//     background-size: contain;
// }

// .btn-wrapper {
//   position: relative;
//   z-index: 9 !important;
// }